import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
// import { SocketContext } from "../../context/Socket/SocketContext";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";

import Title from "../../components/Title";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import CompanyModal from "../../components/CompaniesModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useDate } from "../../hooks/useDate";
import usePlans from "../../hooks/usePlans";
import moment from "moment";
import ColorModeContext from "../../layout/themeContext";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import LaunchIcon from "@material-ui/icons/Launch";
import AssessmentIcon from "@material-ui/icons/Assessment";

const reducer = (state, action) => {
  if (action.type === "LOAD_COMPANIES") {
    const companies = action.payload;
    const newCompanies = [];

    companies.forEach((company) => {
      const companyIndex = state.findIndex((u) => u.id === company.id);
      if (companyIndex !== -1) {
        state[companyIndex] = company;
      } else {
        newCompanies.push(company);
      }
    });

    return [...state, ...newCompanies];
  }

  if (action.type === "UPDATE_COMPANIES") {
    const company = action.payload;
    const companyIndex = state.findIndex((u) => u.id === company.id);

    if (companyIndex !== -1) {
      state[companyIndex] = company;
      return [...state];
    } else {
      return [company, ...state];
    }
  }

  if (action.type === "DELETE_COMPANIES") {
    const companyId = action.payload;

    const companyIndex = state.findIndex((u) => u.id === companyId);
    if (companyIndex !== -1) {
      state.splice(companyIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const Companies = () => {
  const classes = useStyles();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [deletingCompany, setDeletingCompany] = useState(null);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [companies, dispatch] = useReducer(reducer, []);
  const [companyFilter, setCompanyFilter] = useState("active");
  const [refreshKey, setRefreshKey] = useState(0);
  const { dateToClient, datetimeToClient } = useDate();

  // const { getPlanCompany } = usePlans();
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);
  const { mode } = useContext(ColorModeContext);
  const theme = useTheme();

  useEffect(() => {
    async function fetchData() {
      if (!user.super) {
        toast.error(
          "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando."
        );
        setTimeout(() => {
          history.push(`/`);
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam, companyFilter]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchCompanies = async () => {
        try {
          const { data } = await api.get("/companiesPlan/", {
            params: { searchParam, pageNumber, companyStatus: companyFilter },
          });
          dispatch({ type: "LOAD_COMPANIES", payload: data.companies });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
          setLoading(false);
        }
      };
      fetchCompanies();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, companyFilter, refreshKey]);

  const handleOpenCompanyModal = () => {
    setSelectedCompany(null);
    setCompanyModalOpen(true);
  };

  const handleCloseCompanyModal = () => {
    setSelectedCompany(null);
    setCompanyModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardCompany, setDashboardCompany] = useState(null);
  const [impUsersOpen, setImpUsersOpen] = useState(false);
  const [impUsersCompany, setImpUsersCompany] = useState(null);
  const [impUsersList, setImpUsersList] = useState([]);
  const [impUsersLoading, setImpUsersLoading] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelCompany, setCancelCompany] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelConfirmation, setCancelConfirmation] = useState("");
  const [cancelSubmitting, setCancelSubmitting] = useState(false);
  const [purgeDialogOpen, setPurgeDialogOpen] = useState(false);
  const [purgeCompany, setPurgeCompany] = useState(null);
  const [purgePreview, setPurgePreview] = useState(null);
  const [purgeLoading, setPurgeLoading] = useState(false);
  const [purgeConfirmationName, setPurgeConfirmationName] = useState("");
  const [purgeSubmitting, setPurgeSubmitting] = useState(false);

  const handleOpenDashboard = async (company) => {
    setDashboardCompany(company);
    setDashboardOpen(true);
    setDashboardLoading(true);
    try {
      const { data } = await api.get(`/companies/${company.id}/dashboard`);
      setDashboardData(data);
    } catch (err) {
      toastError(err);
      setDashboardOpen(false);
    } finally {
      setDashboardLoading(false);
    }
  };

  const prepareImpersonationWindow = () => {
    const targetWindow = window.open("", "_blank");
    if (!targetWindow) {
      toast.error("O navegador bloqueou a nova aba. Libere pop-ups para acessar o cliente.");
      return null;
    }
    return targetWindow;
  };

  const openImpersonatedSession = (targetWindow, data) => {
    // A nova aba herda o sessionStorage da aba master. Limpamos essa copia e
    // gravamos a sessao do cliente antes de carregar o aplicativo nela.
    targetWindow.sessionStorage.clear();
    targetWindow.sessionStorage.setItem("token", JSON.stringify(data.token));
    if (data.refreshToken) {
      targetWindow.sessionStorage.setItem("refreshToken", data.refreshToken);
    }
    targetWindow.opener = null;
    targetWindow.location.replace(`${window.location.origin}/`);
  };

  const handleImpersonate = async (company) => {
    const targetWindow = prepareImpersonationWindow();
    if (!targetWindow) return;

    try {
      const { data } = await api.post(`/auth/impersonate/${company.id}`);
      openImpersonatedSession(targetWindow, data);
    } catch (err) {
      targetWindow.close();
      toastError(err);
    }
  };

  const handleOpenImpUsers = async (company) => {
    setImpUsersCompany(company);
    setImpUsersOpen(true);
    setImpUsersLoading(true);
    setImpUsersList([]);
    try {
      const { data } = await api.get(`/auth/impersonate/${company.id}/users`);
      setImpUsersList(data.users || []);
    } catch (err) {
      toastError(err);
    } finally {
      setImpUsersLoading(false);
    }
  };

  const handleImpersonateUser = async (userId) => {
    const targetWindow = prepareImpersonationWindow();
    if (!targetWindow) return;

    try {
      const { data } = await api.post(`/auth/impersonate/${impUsersCompany.id}/user/${userId}`);
      setImpUsersOpen(false);
      openImpersonatedSession(targetWindow, data);
    } catch (err) {
      targetWindow.close();
      toastError(err);
    }
  };

  const handleEditCompany = (company) => {
    setSelectedCompany(company);
    setCompanyModalOpen(true);
  };

  const handleDeleteCompany = async (companyId) => {
    try {
      await api.delete(`/companies/${companyId}`);
      toast.success(i18n.t("compaies.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingCompany(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const handleOpenCancelDialog = (company) => {
    setCancelCompany(company);
    setCancelReason("");
    setCancelConfirmation("");
    setCancelDialogOpen(true);
  };

  const handleCancelCompanyBilling = async () => {
    if (!cancelCompany) return;
    if (cancelReason.trim().length < 10 || cancelConfirmation !== "CANCELAR") {
      toast.info("Informe o motivo e digite CANCELAR exatamente como solicitado.");
      return;
    }
    setCancelSubmitting(true);
    try {
      const { data } = await api.post(
        `/billing/companies/${cancelCompany.id}/cancel-local`,
        {
          confirmation: cancelConfirmation,
          reason: cancelReason.trim()
        }
      );
      setCancelDialogOpen(false);
      dispatch({ type: "RESET" });
      setPageNumber(1);
      setRefreshKey(value => value + 1);
      if (data?.sessionShutdown?.complete === false) {
        toast.warn(
          "Cancelamento interno concluido, mas houve aviso ao encerrar uma sessao. Verifique a auditoria."
        );
      } else if (data?.alreadyCancelled) {
        toast.info("Empresa ja estava cancelada; estado conferido novamente.");
      } else {
        toast.success(
          "Empresa cancelada somente no Estratiza e movida para Canceladas. Cancele agora a assinatura manualmente no Asaas."
        );
      }
    } catch (err) {
      toastError(err);
    } finally {
      setCancelSubmitting(false);
    }
  };

  const handleOpenPurgeDialog = async (company) => {
    setPurgeCompany(company);
    setPurgePreview(null);
    setPurgeConfirmationName("");
    setPurgeDialogOpen(true);
    setPurgeLoading(true);
    try {
      const { data } = await api.get(
        `/billing/companies/${company.id}/purge-data/preview`
      );
      setPurgePreview(data);
    } catch (err) {
      toastError(err);
      setPurgeDialogOpen(false);
    } finally {
      setPurgeLoading(false);
    }
  };

  const purgeNameMatches =
    Boolean(purgeCompany) &&
    purgeConfirmationName.trim() === String(purgeCompany.name || "").trim();

  const purgeBlockers = purgePreview?.blockers || [];

  const handlePurgeCompanyData = async () => {
    if (!purgeCompany || !purgePreview || !purgeNameMatches || purgeBlockers.length) return;
    setPurgeSubmitting(true);
    try {
      const { data } = await api.post(
        `/billing/companies/${purgeCompany.id}/purge-data`,
        { confirmationName: purgeConfirmationName.trim() }
      );
      setPurgeDialogOpen(false);
      dispatch({ type: "RESET" });
      setPageNumber(1);
      setRefreshKey(value => value + 1);
      if (!data?.complete) {
        toast.warn(
          `Exclusão parcial: ${data?.totalDeletedRows || 0} registros apagados, mas ${data?.pending?.length || 0} item(ns) ficaram pendentes. Use "Concluir exclusão" para repetir.`
        );
      } else {
        toast.success(
          `Dados excluidos: ${data?.totalDeletedRows || 0} registros e ${data?.mediaRemoved?.length || 0} pasta(s) de arquivos.`
        );
      }
    } catch (err) {
      toastError(err);
    } finally {
      setPurgeSubmitting(false);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const renderStatus = (row) => {
    return row.status === false ? "Não" : "Sim";
  };

  const renderPlanValue = (row) => {
    if (!row.plan) return "-";
    const amt = parseFloat(String(row.plan.amount || "0").replace(",", "."));
    return amt ? amt.toLocaleString("pt-br", { minimumFractionDigits: 2 }) : "00.00";
  };

  const renderWhatsapp = (row) => {
    return row.useWhatsapp === false ? "Não" : "Sim";
  };

  const renderFacebook = (row) => {
    return row.useFacebook === false ? "Não" : "Sim";
  };

  const renderInstagram = (row) => {
    return row.useInstagram === false ? "Não" : "Sim";
  };

  const renderCampaigns = (row) => {
    return row.useCampaigns === false ? "Não" : "Sim";
  };

  const renderSchedules = (row) => {
    return row.useSchedules === false ? "Não" : "Sim";
  };

  const renderInternalChat = (row) => {
    return row.useInternalChat === false ? "Não" : "Sim";
  };

  const renderExternalApi = (row) => {
    return row.useExternalApi === false ? "Não" : "Sim";
  };

  const rowStyle = (record) => {
    if (moment(record.dueDate).isValid()) {
      const now = moment();
      const dueDate = moment(record.dueDate);
      const diff = dueDate.diff(now, "days");
      if (diff >= 1 && diff <= 5) {
        return { backgroundColor: "#fffead" };
      }
      if (diff <= 0) {
        return { backgroundColor: "#fa8c8c" };
      }
    }
    return {};
  };

  const cellStyle = (record) => {
    if (moment(record.dueDate).isValid()) {
      const now = moment();
      const dueDate = moment(record.dueDate);
      const diff = dueDate.diff(now, "days");
      if (diff >= 1 && diff <= 5) {
        return { color: "#000" };
      }
      if (diff <= 0) {
        return { color: "#fff" };
      }
    }
    return {};
  };

  const formatFolderSize = (size) => {
    if (!size || size === 0) return '0 Bytes';
    
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    let index = 0;
    let formattedSize = size;

    while (formattedSize >= 1024 && index < units.length - 1) {
        formattedSize /= 1024;
        index++;
    }

    return `${formattedSize.toFixed(2)} ${units[index]}`;
};

  const fmtCur = (v) => Number(v||0).toLocaleString("pt-br",{style:"currency",currency:"BRL"});
  const fmtDate = (d) => d && moment(d).isValid() ? moment(d).format("DD/MM/YYYY") : "-";
  const connStatusColor = (s) => s==="CONNECTED" ? "#1b5e20" : s==="DISCONNECTED" ? "#b71c1c" : "#e65100";
  const connStatusBg = (s) => s==="CONNECTED" ? "#e8f5e9" : s==="DISCONNECTED" ? "#ffebee" : "#fff3e0";
  const connStatusLabel = (s) => s==="CONNECTED" ? "Conectado" : s==="DISCONNECTED" ? "Desconectado" : s||"?";

  const card = (label, value, color) => (
    <div style={{ background: "#f5f5f5", borderRadius: 8, padding: "12px 18px", textAlign: "center", minWidth: 100 }}>
      <div style={{ fontSize: "0.75rem", color: "#666", marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: "1.5rem", fontWeight: 800, color: color||"#333" }}>{value}</div>
    </div>
  );

  const q = searchParam.trim().toLowerCase();
  const filteredCompanies = q
    ? companies.filter(c =>
        (c.name||"").toLowerCase().includes(q) ||
        (c.email||"").toLowerCase().includes(q)
      )
    : companies;

  return (
    <>
    {/* ── Client Dashboard Modal ────────────────────────── */}
    <Dialog open={dashboardOpen} onClose={() => setDashboardOpen(false)} maxWidth="md" fullWidth>
      <DialogTitle style={{ display:"flex", justifyContent:"space-between", alignItems:"center", paddingBottom: 8 }}>
        <span>{dashboardCompany?.name} — Painel do Cliente</span>
        <IconButton size="small" onClick={() => setDashboardOpen(false)}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent>
        {dashboardLoading && <div style={{ textAlign:"center", padding: 40, color:"#888" }}>Carregando...</div>}
        {!dashboardLoading && dashboardData && (() => {
          const { company, usersCount, connections, queuesCount, invoices } = dashboardData;
          const since = company?.createdAt ? moment(company.createdAt) : null;
          const sinceStr = since ? since.format("DD/MM/YYYY") + " (" + since.fromNow(true) + ")" : "-";
          const activeConn = (connections||[]).filter(cn=>cn.status==="CONNECTED").length;
          const paidInvoices = (invoices||[]).filter(inv=>inv.status==="paid");
          const totalPaid = paidInvoices.reduce((s,i)=>s+Number(i.value||0),0);
          return (
          <div style={{ paddingBottom: 16 }}>
            {/* Summary cards */}
            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:20 }}>
              {card("Cliente desde", sinceStr.split(" ")[0], "#1565c0")}
              {card("Usuarios", usersCount, "#4a148c")}
              {card("Filas", queuesCount, "#e65100")}
              {card("Conexoes", (connections||[]).length, "#1b5e20")}
              {card("Ativas", activeConn, activeConn>0?"#1b5e20":"#b71c1c")}
              {card("Total pago", fmtCur(totalPaid), "#1565c0")}
            </div>
            <div style={{ fontSize:"0.8rem", color:"#666", marginBottom:16 }}>Cliente desde: <strong>{sinceStr}</strong></div>

            {/* Connections */}
            <Divider style={{ margin:"12px 0 8px" }} />
            <div style={{ fontWeight:700, marginBottom:8 }}>Conexoes WhatsApp / Canal</div>
            {(connections||[]).length === 0 && <div style={{ color:"#888", fontSize:"0.85rem" }}>Nenhuma conexao cadastrada</div>}
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {(connections||[]).map(cn => (
                <div key={cn.id} style={{ border:"1px solid #eee", borderRadius:8, padding:"8px 12px", minWidth:160 }}>
                  <div style={{ fontWeight:600, fontSize:"0.85rem" }}>{cn.name}</div>
                  <div style={{ fontSize:"0.72rem", color:"#888" }}>{cn.channel||"whatsapp"}</div>
                  <span style={{ display:"inline-block", marginTop:4, padding:"2px 10px", borderRadius:12, fontSize:"0.72rem", fontWeight:700,
                    background:connStatusBg(cn.status), color:connStatusColor(cn.status) }}>
                    {connStatusLabel(cn.status)}
                  </span>
                </div>
              ))}
            </div>

            {/* Financial history */}
            <Divider style={{ margin:"16px 0 8px" }} />
            <div style={{ fontWeight:700, marginBottom:8 }}>Historico Financeiro</div>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.82rem" }}>
              <thead><tr style={{ background:"#f5f5f5" }}>
                <th style={{ padding:"6px 8px", textAlign:"left" }}>Plano</th>
                <th style={{ padding:"6px 8px", textAlign:"center" }}>Valor</th>
                <th style={{ padding:"6px 8px", textAlign:"center" }}>Vencimento</th>
                <th style={{ padding:"6px 8px", textAlign:"center" }}>Status</th>
              </tr></thead>
              <tbody>
                {(invoices||[]).map(inv => (
                  <tr key={inv.id} style={{ borderBottom:"1px solid #f0f0f0" }}>
                    <td style={{ padding:"5px 8px" }}>{inv.plan?.name || inv.detail || "-"}</td>
                    <td style={{ padding:"5px 8px", textAlign:"center", fontWeight:600 }}>{fmtCur(inv.value)}</td>
                    <td style={{ padding:"5px 8px", textAlign:"center" }}>{fmtDate(inv.dueDate)}</td>
                    <td style={{ padding:"5px 8px", textAlign:"center" }}>
                      <span style={{ padding:"2px 10px", borderRadius:12, fontSize:"0.72rem", fontWeight:700,
                        background:inv.status==="paid"?"#e8f5e9":"#fff3e0",
                        color:inv.status==="paid"?"#1b5e20":"#e65100" }}>
                        {inv.status==="paid" ? "Pago" : "Em aberto"}
                      </span>
                    </td>
                  </tr>
                ))}
                {(invoices||[]).length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign:"center", color:"#888", padding:16 }}>Nenhuma fatura encontrada</td></tr>
                )}
              </tbody>
            </table>
          </div>
          );
        })()}
      </DialogContent>
    </Dialog>

    {/* Impersonate Specific User Modal */}
    <Dialog open={impUsersOpen} onClose={() => setImpUsersOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle style={{ display:"flex", justifyContent:"space-between", alignItems:"center", paddingBottom: 8 }}>
        <span>{impUsersCompany?.name} — Entrar como usuário</span>
        <IconButton size="small" onClick={() => setImpUsersOpen(false)}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent>
        {impUsersLoading && <div style={{ textAlign:"center", padding: 30, color:"#888" }}>Carregando...</div>}
        {!impUsersLoading && impUsersList.length === 0 && <div style={{ textAlign:"center", padding: 30, color:"#888" }}>Nenhum usuário encontrado.</div>}
        {!impUsersLoading && impUsersList.map((u) => (
          <div key={u.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 4px", borderBottom:"1px solid #eee" }}>
            <div>
              <div style={{ fontWeight:600, fontSize:"0.9rem" }}>{u.name}</div>
              <div style={{ fontSize:"0.75rem", color:"#888" }}>{u.email} · {u.profile}</div>
            </div>
            <button
              onClick={() => handleImpersonateUser(u.id)}
              style={{ padding:"4px 14px", borderRadius:6, background:"#1565c0", color:"#fff", border:"none", cursor:"pointer", fontWeight:600, fontSize:"0.78rem" }}
            >
              Entrar
            </button>
          </div>
        ))}
      </DialogContent>
    </Dialog>

    {/* ── Original page content ─────────────────────────── */}
    <Dialog
      open={cancelDialogOpen}
      onClose={() => !cancelSubmitting && setCancelDialogOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Cancelar empresa — {cancelCompany?.name}</DialogTitle>
      <DialogContent>
        <div style={{
          padding: 14,
          borderRadius: 8,
          background: "#fff3e0",
          border: "1px solid #ffb74d",
          marginBottom: 16
        }}>
          <div style={{ fontWeight: 700, color: "#e65100", fontSize: "1.05rem" }}>
            Este botão cancela somente dentro do Estratiza.
          </div>
          <div style={{ marginTop: 6, fontSize: "0.86rem", color: "#5d4037" }}>
            Nenhuma consulta ou alteração será feita no Asaas. Depois de confirmar,
            entre no Asaas e cancele manualmente a assinatura e as cobranças desta empresa.
          </div>
        </div>
        <div style={{ fontSize: "0.86rem", marginBottom: 14 }}>
          A empresa será movida para Canceladas e suas sessões locais serão encerradas.
          Contatos, tickets, mensagens, mídias, usuários e histórico serão preservados
          até você usar, separadamente, a futura opção Excluir dados.
        </div>
        <TextField
          label="Motivo do cancelamento"
          value={cancelReason}
          onChange={event => setCancelReason(event.target.value)}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          inputProps={{ maxLength: 500 }}
          helperText="Mínimo de 10 caracteres"
          disabled={cancelSubmitting}
        />
        <TextField
          label="Digite CANCELAR para confirmar"
          value={cancelConfirmation}
          onChange={event => setCancelConfirmation(event.target.value)}
          fullWidth
          variant="outlined"
          margin="normal"
          disabled={cancelSubmitting}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setCancelDialogOpen(false)} disabled={cancelSubmitting}>
          Voltar
        </Button>
        <Button
          onClick={handleCancelCompanyBilling}
          color="secondary"
          variant="contained"
          disabled={
            cancelSubmitting ||
            cancelReason.trim().length < 10 ||
            cancelConfirmation !== "CANCELAR"
          }
        >
          {cancelSubmitting ? "Cancelando..." : "Cancelar somente no Estratiza"}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={purgeDialogOpen}
      onClose={() => !purgeSubmitting && setPurgeDialogOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Excluir dados — {purgeCompany?.name}</DialogTitle>
      <DialogContent>
        <div style={{
          padding: 14,
          borderRadius: 8,
          background: "#ffebee",
          border: "1px solid #e57373",
          marginBottom: 16
        }}>
          <div style={{ fontWeight: 700, color: "#b71c1c", fontSize: "1.05rem" }}>
            AÇÃO IRREVERSÍVEL.
          </div>
          <div style={{ marginTop: 6, fontSize: "0.86rem", color: "#5d4037" }}>
            Mensagens, tickets, contatos, conexões, usuários, filas, fluxos e arquivos
            desta empresa serão apagados do sistema e do servidor. O cadastro da empresa,
            as faturas, o financeiro e a auditoria serão mantidos. Backups gerais antigos
            continuam existindo até expirarem.
          </div>
        </div>
        {purgeLoading && (
          <div style={{ padding: 16, textAlign: "center", color: "#777" }}>
            Contando os dados da empresa...
          </div>
        )}
        {!purgeLoading && purgePreview && (
          <div style={{ fontSize: "0.86rem", marginBottom: 14 }}>
            <div>
              Será apagado: <b>{(purgePreview.totalRows || 0).toLocaleString()}</b> registros
              {" "}(mensagens: {(purgePreview.counts?.Messages || 0).toLocaleString()},
              {" "}tickets: {(purgePreview.counts?.Tickets || 0).toLocaleString()},
              {" "}contatos: {(purgePreview.counts?.Contacts || 0).toLocaleString()},
              {" "}conexões: {(purgePreview.counts?.Whatsapps || 0).toLocaleString()},
              {" "}usuários: {(purgePreview.counts?.Users || 0).toLocaleString()}).
            </div>
            <div style={{ marginTop: 4 }}>
              Arquivos: {formatFolderSize(purgePreview.mediaBytes || 0)} em
              {" "}{(purgePreview.mediaFiles || 0).toLocaleString()} arquivo(s),
              {" "}{(purgePreview.mediaFolders || []).length} pasta(s).
            </div>
            {purgePreview.apiOficial?.checked && (
              <div style={{ marginTop: 4 }}>
                API Oficial: {purgePreview.apiOficial.apiCompanyId
                  ? `${purgePreview.apiOficial.counts?.whatsappOficial || 0} conexão(ões) e ${(purgePreview.apiOficial.counts?.sendMessageWhatsApp || 0).toLocaleString()} envio(s) locais`
                  : "nenhum dado"}.
              </div>
            )}
            {purgePreview.state === "PARTIAL" && (
              <div style={{ marginTop: 8, color: "#e65100", fontWeight: 600 }}>
                Exclusão anterior ficou parcial. Confirmar repete somente o que faltou
                {(purgePreview.previousPending || []).length
                  ? ` (${purgePreview.previousPending.length} pendência(s))`
                  : ""}.
              </div>
            )}
          </div>
        )}
        {!purgeLoading && purgeBlockers.length > 0 && (
          <div style={{
            padding: 12,
            borderRadius: 8,
            background: "#fff3e0",
            border: "1px solid #ffb74d",
            marginBottom: 12,
            fontSize: "0.82rem"
          }}>
            <div style={{ fontWeight: 700, color: "#e65100" }}>
              Exclusão bloqueada. Nada será apagado até resolver:
            </div>
            {purgeBlockers.map(blocker => (
              <div key={`${blocker.code}:${blocker.detail}`} style={{ marginTop: 4 }}>
                {blocker.code}{blocker.detail ? ` — ${blocker.detail}` : ""}
              </div>
            ))}
          </div>
        )}
        <TextField
          label="Digite o nome exato da empresa para confirmar"
          value={purgeConfirmationName}
          onChange={event => setPurgeConfirmationName(event.target.value)}
          fullWidth
          variant="outlined"
          margin="normal"
          helperText={purgeCompany ? `Nome: ${purgeCompany.name}` : ""}
          disabled={purgeSubmitting || purgeLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPurgeDialogOpen(false)} disabled={purgeSubmitting}>
          Voltar
        </Button>
        <Button
          onClick={handlePurgeCompanyData}
          color="secondary"
          variant="contained"
          disabled={purgeSubmitting || purgeLoading || !purgePreview || !purgeNameMatches || purgeBlockers.length > 0}
        >
          {purgeSubmitting
            ? "Excluindo..."
            : purgePreview?.state === "PARTIAL"
              ? "Concluir exclusão"
              : "Excluir dados definitivamente"}
        </Button>
      </DialogActions>
    </Dialog>

    <MainContainer>

      <ConfirmationModal
        title={
          deletingCompany &&
          `${i18n.t("compaies.confirmationModal.deleteTitle")} ${
            deletingCompany.name
          }?`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteCompany(deletingCompany.id)}
      >
        {i18n.t("compaies.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <CompanyModal
        open={companyModalOpen}
        onClose={handleCloseCompanyModal}
        aria-labelledby="form-dialog-title"
        companyId={selectedCompany && selectedCompany.id}
      />
      <MainHeader>
        <Title>
          {i18n.t("compaies.title")} ({companies.length})
        </Title>
        {/* <MainHeaderButtonsWrapper>
                    <TextField
                        placeholder={i18n.t("contacts.searchPlaceholder")}
                        type="search"
                        value={searchParam}
                        onChange={handleSearch}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon style={{ color: "gray" }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleOpenCompanyModal}
                    >
                        {i18n.t("compaies.buttons.add")}
                    </Button>
                </MainHeaderButtonsWrapper> */}
      </MainHeader>
      <div style={{ display: "flex", gap: 8, paddingTop: 8 }}>
        {[
          ["active", "Ativas"],
          ["cancelled", "Canceladas"],
          ["all", "Todas"]
        ].map(([value, label]) => (
          <Button
            key={value}
            size="small"
            variant={companyFilter === value ? "contained" : "outlined"}
            color={companyFilter === value ? "primary" : "default"}
            onClick={() => setCompanyFilter(value)}
          >
            {label}
          </Button>
        ))}
      </div>
      <div style={{ padding: "10px 0 6px 0", display: "flex", alignItems: "center", gap: 12 }}>
        <TextField
          placeholder="Buscar por nome ou email..."
          type="search"
          value={searchParam}
          onChange={handleSearch}
          size="small"
          variant="outlined"
          style={{ minWidth: 280 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "gray", fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
        <span style={{ fontSize: "0.8rem", color: "#888" }}>
          {filteredCompanies.length} empresa{filteredCompanies.length !== 1 ? "s" : ""}
        </span>
      </div>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {i18n.t("compaies.table.ID")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.status")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.name")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.email")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.namePlan")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.value")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.createdAt")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.dueDate")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.lastLogin")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.folderSize")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.totalFiles")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("compaies.table.lastUpdate")}
              </TableCell>
              {/* <TableCell align="center">{i18n.t("compaies.table.numberAttendants")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.numberConections")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.numberQueues")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useWhatsapp")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useFacebook")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useInstagram")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useCampaigns")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useExternalApi")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useInternalChat")}</TableCell> */}
              {/* <TableCell align="center">{i18n.t("compaies.table.useSchedules")}</TableCell> */}
              <TableCell align="center">Tokens IA</TableCell>
              <TableCell align="center">Acoes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {filteredCompanies.map((company) => (
                <TableRow style={rowStyle(company)} key={company.id}>
                  <TableCell style={cellStyle(company)} align="center">{company.id}</TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    {company.isSafelyCancelled ? (
                      <Chip
                        size="small"
                        label="CANCELADA"
                        style={{ background: "#ffebee", color: "#b71c1c", fontWeight: 700 }}
                      />
                    ) : company.status === false ? (
                      <Chip
                        size="small"
                        label="INATIVA"
                        style={{ background: "#eeeeee", color: "#555", fontWeight: 700 }}
                      />
                    ) : (
                      renderStatus(company.status)
                    )}
                  </TableCell>
                  <TableCell style={cellStyle(company)} align="center">{company.name}</TableCell>
                  <TableCell style={cellStyle(company)} align="center">{company.email}</TableCell>
                  <TableCell style={cellStyle(company)} align="center">{company?.plan?.name}</TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    R$ {renderPlanValue(company)}
                  </TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    {dateToClient(company.createdAt)}
                  </TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    {dateToClient(company.dueDate)}
                    <br />
                    <span style={cellStyle(company)}>{company.recurrence}</span>
                  </TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    {datetimeToClient(company.lastLogin)}
                  </TableCell>
                  <TableCell style={cellStyle(company)} align="center">{formatFolderSize(company?.metrics?.folderSize || 0)}</TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    {company?.metrics?.numberOfFiles || 0}
                  </TableCell>
                  <TableCell style={cellStyle(company)} align="center">
                    {datetimeToClient(company?.metrics?.lastUpdate || 'Não disponível')}
                  </TableCell>
                  {/* <TableCell align="center">{company.plan.users}</TableCell> */}
                  {/* <TableCell align="center">{company.plan.connections}</TableCell> */}
                  {/* <TableCell align="center">{company.plan.queues}</TableCell> */}
                  {/* <TableCell align="center">{renderWhatsapp(company.plan.useWhatsapp)}</TableCell> */}
                  {/* <TableCell align="center">{renderFacebook(company.plan.useFacebook)}</TableCell> */}
                  {/* <TableCell align="center">{renderInstagram(company.plan.useInstagram)}</TableCell> */}
                  {/* <TableCell align="center">{renderCampaigns(company.plan.useCampaigns)}</TableCell> */}
                  {/* <TableCell align="center">{renderExternalApi(company.plan.useExternalApi)}</TableCell> */}
                  {/* <TableCell align="center">{renderInternalChat(company.plan.useInternalChat)}</TableCell> */}
                  {/* <TableCell align="center">{renderSchedules(company.plan.useSchedules)}</TableCell> */}
                  <TableCell align="center">
                    {(() => {
                      const limit = company?.plan?.aiTokensLimit || 0;
                      const used = company?.aiTokensUsed || 0;
                      if (limit === 0) return <span style={{color:"#999",fontSize:"0.75rem"}}>—</span>;
                      const pct = Math.min(100, Math.round((used / limit) * 100));
                      const color = pct >= 90 ? "#c62828" : pct >= 70 ? "#e65100" : "#2e7d32";
                      return (
                        <div style={{textAlign:"center"}}>
                          <div style={{fontSize:"0.75rem",fontWeight:600,color}}>{used.toLocaleString()} / {limit.toLocaleString()}</div>
                          <div style={{background:"#eee",borderRadius:4,height:6,margin:"3px 0"}}>
                            <div style={{background:color,width:`${pct}%`,height:"100%",borderRadius:4,transition:"width 0.3s"}} />
                          </div>
                          <div style={{fontSize:"0.7rem",color}}>{pct}%</div>
                        </div>
                      );
                    })()}
                  </TableCell>
                  <TableCell align="center">
                    {company.status !== false && (
                      <button
                        onClick={() => handleOpenImpUsers(company)}
                        title="Acessar sistema do cliente"
                        style={{
                          marginRight: 6, padding: "4px 12px", borderRadius: 6,
                          background: "#1565c0", color: "#fff", border: "none",
                          cursor: "pointer", fontWeight: 600, fontSize: "0.78rem"
                        }}
                      >
                        Acessar
                      </button>
                    )}
                    <button
                      onClick={() => handleOpenDashboard(company)}
                      title="Ver painel do cliente"
                      style={{
                        padding: "4px 12px", borderRadius: 6,
                        background: "#4a148c", color: "#fff", border: "none",
                        cursor: "pointer", fontWeight: 600, fontSize: "0.78rem"
                      }}
                    >
                      Painel
                    </button>
                    {company.status !== false && (
                      <button
                        onClick={() => handleOpenCancelDialog(company)}
                        title="Cancelar somente no Estratiza; o Asaas deve ser cancelado manualmente"
                        style={{
                          marginLeft: 6, padding: "4px 12px", borderRadius: 6,
                          background: "#b71c1c", color: "#fff", border: "none",
                          cursor: "pointer", fontWeight: 600, fontSize: "0.78rem"
                        }}
                      >
                        Cancelar
                      </button>
                    )}
                    {company.isDataPurgeEnabled === true && company.isSafelyCancelled && company.status === false && !company.isDataPurged && (
                      <button
                        onClick={() => handleOpenPurgeDialog(company)}
                        title="Apagar definitivamente os dados de atendimento desta empresa cancelada"
                        style={{
                          marginLeft: 6, padding: "4px 12px", borderRadius: 6,
                          background: company.isDataPurgePartial ? "#e65100" : "#212121",
                          color: "#fff", border: "none",
                          cursor: "pointer", fontWeight: 600, fontSize: "0.78rem"
                        }}
                      >
                        {company.isDataPurgePartial ? "Concluir exclusão" : "Excluir dados"}
                      </button>
                    )}
                    {company.isDataPurgePartial && (
                      <span style={{ marginLeft: 6, fontSize: "0.75rem", color: "#e65100", fontWeight: 600 }}>
                        Exclusão parcial
                      </span>
                    )}
                    {company.isDataPurged && (
                      <span style={{ marginLeft: 6, fontSize: "0.75rem", color: "#777", fontWeight: 600 }}>
                        Dados excluídos
                      </span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton columns={4} />}
            </>
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
    </>
  );
};

export default Companies;
